var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppointmentView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67884 11.9317C6.09143 11.3109 6.9206 10.1815 8.0447 9.21477C9.17567 8.2421 10.5274 7.5 12 7.5C13.4726 7.5 14.8244 8.2421 15.9553 9.21477C17.0794 10.1815 17.9086 11.3109 18.3212 11.9317C18.35 11.975 18.35 12.025 18.3212 12.0683C17.9086 12.6891 17.0794 13.8185 15.9553 14.7852C14.8244 15.7579 13.4726 16.5 12 16.5C10.5274 16.5 9.17567 15.7579 8.0447 14.7852C6.9206 13.8185 6.09143 12.6891 5.67884 12.0683C5.65002 12.025 5.65002 11.975 5.67884 11.9317ZM12 6C10.0186 6 8.32919 6.99167 7.06662 8.07751C5.79718 9.16926 4.88045 10.4231 4.42963 11.1013C4.06642 11.6477 4.06642 12.3523 4.42963 12.8987C4.88045 13.5769 5.79718 14.8307 7.06662 15.9225C8.32919 17.0083 10.0186 18 12 18C13.9814 18 15.6708 17.0083 16.9334 15.9225C18.2028 14.8307 19.1196 13.5769 19.5704 12.8987C19.9336 12.3523 19.9336 11.6477 19.5704 11.1013C19.1196 10.4231 18.2028 9.16926 16.9334 8.07751C15.6708 6.99167 13.9814 6 12 6ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
    fill: "#C7CBE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentView);
export default __webpack_public_path__ + "static/media/appointment-view.cb984ae6eaf1ad013b96d451c155740e.svg";
export { ForwardRef as ReactComponent };